import { useState } from "react";
import { Link } from "react-router-dom";
import Blink from "../../../components/blink";
import Icons from "../../../components/iconMaster/Icons";
import PlanYourTripModal from "../../home/amazingDeals/planYourTripModal";

export default function Footer({
  globalSearchPopup,
  setGlobalSearchPopup,
  onRequestCallback,
}: any) {
  const [showPlanTripModal, setShowPlanTripModal] = useState(false);
  const [planTripTab, setPlanTripTab] = useState<"flight" | "hotel" | "insurance">("flight");

  const openPlanTripEnquiry = (tab: "flight" | "hotel" | "insurance") => {
    setPlanTripTab(tab);
    setShowPlanTripModal(true);
  };

  return (
    <>
      <footer className="footer" style={{ borderTop: "solid 3px #ef4444" }}>

        <div className="footer-top" style={{ background: "#000000" }}>
          <div className="container">
            <div className="feature-wrapper py-4 gap-4">

              <div className="feature-item align-items-start">
                <div className="feature-icon bg-transparent border-0">
                  <Icons
                    name="newsletter"
                    width="32px"
                    height="32px"
                    fill="#ef4444"
                  />
                </div>

                <div className="feature-content">
                  <h4 className="text-base text-white mb-1 ropa-sans-regular">Plan Your Next Journey</h4>
                  <p className="text-sm" style={{ color: "#bcbcbc" }}>
                    Get exclusive travel deals, offers and updates straight to your inbox.
                  </p>
                </div>
              </div>

              <div className="subscribe-box">
                <div className="input-group subscribe-group">

                  <span className="input-icon">
                    <i className="bx bx-envelope"></i>
                  </span>

                  <input
                    type="email"
                    className="form-control border-0 shadow-none"
                    placeholder="Enter your email address"
                  />

                  <button
                    type="button"
                    className="btn btn-primary rounded-0 px-4 w-auto"
                  >
                    Subscribe
                  </button>

                </div>
              </div>

              <div className="feature-item align-items-start">
                <div className="feature-icon bg-transparent border-0">
                  <Icons
                    name="best-offer"
                    width="32px"
                    height="32px"
                    fill="#ef4444"
                  />
                </div>

                <div className="feature-content">
                  <h4 className="text-base text-white mb-1 ropa-sans-regular">Best Price Guarantee</h4>
                  <p className="text-sm" style={{ color: "#bcbcbc" }}>We give you the best price <br /> or match it.</p>
                </div>
              </div>

              <div className="feature-item align-items-start">
                <div className="feature-icon bg-transparent border-0">
                  <Icons
                    name="sales-support"
                    width="32px"
                    height="32px"
                    fill="#ef4444"
                  />
                </div>

                <div className="feature-content">
                  <h4 className="text-base text-white mb-1 ropa-sans-regular">24/7 Travel Support</h4>
                  <p>We are here to assist you anytime, anywhere.</p>
                </div>
              </div>

            </div>
          </div>
        </div>

        <div className="footer-content pt-4 pb-0">
          <div className="container position-relative">
            <div className="row">

              <div className="col-xl-3 col-md-3 col-6">
                <div className="footer-widget mb-4">
                  <div className="footer-widget-heading">
                    <h3 className="ropa-sans-regular">Company</h3>
                  </div>
                  <ul className="arrow">
                    <li><Link to="/">Home</Link></li>
                    <li><Link to="/about-us">About Genius World </Link></li>
                    <li><Link to="/">Why Genius World</Link></li>
                    <li><Link to="/contact">Contact Us</Link></li>
                    <li><Link to="/">Awards & Recognition</Link></li>
                  </ul>
                </div>
              </div>
              <div className="col-xl-3 col-md-3 col-6">
                <div className="footer-widget mb-4">
                  <div className="footer-widget-heading">
                    <h3 className="ropa-sans-regular">Resources</h3>
                  </div>
                  <ul className="arrow">
                    <li><Link to="/blog-artical">Blogs</Link></li>
                    <li><a role="button">Videos</a></li>
                    <li><Link to="/blog-artical">Articles</Link></li>
                    <li><a role="button">Podcasts</a></li>
                    <li><Link to="/blog-artical#ebrochures">E-Brochures</Link></li>
                  </ul>
                </div>
              </div>
              <div className="col-xl-3 col-md-3 col-6">
                <div className="footer-widget mb-4">
                  <div className="footer-widget-heading">
                    <h3 className="ropa-sans-regular">Support</h3>
                  </div>
                  <ul className="arrow">
                    {/* <li><a role="button">Help Centre / FAQs</a></li>
                    <li><a role="button">How To Book</a></li>
                    <li><a role="button">Contact Support</a></li>
                    <li><Link to="/leave-feedback">Leave Feedback</Link></li>
                    <li><a role="button">Corporate Governance</a></li> */}
                    <li><Link to="/contact">Help Centre / FAQs</Link></li>
                    <li><Link to="/contact">How To Book</Link></li>
                    <li><Link to="/contact">Contact Support</Link></li>
                    <li><Link to="/contact">Leave Feedback</Link></li>
                    <li><Link to="/contact">Corporate Governance</Link></li>
                  </ul>
                </div>
              </div>
              <div className="col-xl-3 col-md-3 col-6">
                <div className="footer-widget mb-4">
                  <div className="footer-widget-heading">
                    <h3 className="ropa-sans-regular">Discover Us</h3>
                  </div>
                  <ul className="arrow">
                    <li><Link to="/about-us">Our Leadership</Link></li>
                    <li><Link to="/tour-manager">Meet Our Tour Managers</Link></li>
                    <li><Link to="/careers">Careers </Link> <Blink><span className="text-primary fw-bold">We’re Hiring!</span></Blink></li>
                    <li><a role="button">Newsroom</a></li>
                    <li><Link to="/testimonials">Testimonials</Link></li>
                  </ul>
                </div>
              </div>
              <div className="col-xl-3 col-md-3 col-6">
                <div className="footer-widget mb-4">
                  <div className="footer-widget-heading">
                    <h3 className="ropa-sans-regular">Partners Zone</h3>
                  </div>
                  <ul className="arrow">
                    <li><Link to="/become-sales-partner">Become A Sales Partner</Link></li>
                    <li><Link to="/sales-partners">Preferred Sales Agent (PSA)</Link></li>
                    <li><a role="button">Franchise Opportunities</a></li>
                    <li><Link to="/travel-agent">Travel Agent Registration</Link></li>
                    <li><a href={`https://partner${process.env.REACT_APP_ENV === "qa" ? "qa" : ""}.geniusworld.in`} target="_blank">Partners Login</a></li>
                  </ul>
                </div>
              </div>
              <div className="col-xl-3 col-md-3 col-6">
                <div className="footer-widget mb-4">
                  <div className="footer-widget-heading">
                    <h3 className="ropa-sans-regular">Travel Assistance</h3>
                  </div>
                  <ul className="arrow">
                    <li><Link to="/visaAssistance">Visa Assistance</Link></li>
                    <li><Link to="/passport">Passport Assistance</Link></li>
                    <li><a role="button" onClick={() => openPlanTripEnquiry("flight")}>Flight Booking</a></li>
                    <li><a role="button" onClick={() => openPlanTripEnquiry("hotel")}>Hotel Booking</a></li>
                    <li><a role="button" onClick={() => openPlanTripEnquiry("insurance")}>Travel Insurance</a></li>
                  </ul>
                </div>
              </div>
              <div className="col-xl-3 col-md-3 col-6">
                <div className="footer-widget mb-4">
                  <div className="footer-widget-heading">
                    <h3 className="ropa-sans-regular">Book & Manage</h3>
                  </div>
                  <ul className="arrow">
                    <li><Link to="/bookManage">My Booking</Link></li>
                    <li><a role="button" onClick={onRequestCallback}>Request a Callback</a></li>
                    <li><a role="button">Online Payment</a> <Blink><span className="text-primary fw-bold">New</span></Blink></li>
                    <li><a role="button">Gift Cards</a></li>
                    <li><a role="button">EMI Calculator</a></li>
                  </ul>
                </div>
              </div>
              {/* <div className="col-xl-3 col-md-3 col-6">
                <div className="footer-logo mt-2">
                  <img loading="lazy" height={32} src="../../../assets/images/bw-logo.png" alt="" />
                  <p style={{color:"#bcbcbc"}}>Shop No. 104, First Floor 'SAI PANASH CHS LTD' <br /> Opp. Sai Baba Mandir, Temghar, Taluka Bhiwandi, <br /> Dist Thane - 421302 Maharashtra, India.</p>
                </div>
              </div> */}
              <div className="col-xl-3 col-md-6 col-12">
                <div className="footer-widget footer-app-promo mb-4">
                  <div className="footer-widget-heading">
                    <h3 className="ropa-sans-regular">Genius World App</h3>
                  </div>
                  <div className="footer-widget">
                    <p className="mb-2 text-white-50">Download the app to book and manage your tour on the go. <a role="button">Learn more Details</a></p>
                    <div className="app-logo">
                      <img loading="lazy" src="../../../assets/images/appstore-logo.svg" alt="Download on the App Store" />
                      <img loading="lazy" src="../../../assets/images/google-play-logo.svg" alt="Get it on Google Play" />
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div className="footer-social mb-3" style={{background: "#0f0f0f", border: "dotted 1px #868686", padding: "15px", borderRadius: "12px" }}>
              <div className="row align-items-center">

                <div className="col-xl-6 col-md-4">
                  <div className="footer-widget">
                    <ul className="grid">
                      <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                      <li><Link to="/terms-condition">Terms & Conditions</Link></li>
                      <li><Link to="/cookies">Cookie Policy</Link></li>
                      <li><Link to="/">Payment Policy</Link></li>
                      <li><Link to="/">GST Information</Link></li>
                      <li><Link to="/csr-policy">CSRs Policy</Link></li>
                    </ul>
                  </div>
                </div>
                <div className="col-xl-3 col-md-4">
                  <div className="footer-logo">
                    <img loading="lazy" className="img-fluid" src="../../../assets/images/bw-logo.png" alt="" />
                  </div>
                </div>
                <div className="col-xl-3 col-md-4">
                  <div className="footer-widget-heading">
                    <h3 className="ropa-sans-regular">Follow Us</h3>
                  </div>
                  <div className="footer-social-icon">
                    <a href="https://www.facebook.com/geniusworld.travel?utm_source=ig&utm_medium=social&utm_content=link_in_bio" target="_blank"><i className='bx bxl-facebook-circle'></i></a>
                    <a href="https://www.linkedin.com/company/genius-world-tourism-pvt-ltd" target="_blank"><i className='bx bxl-linkedin' ></i></a>
                    <a href="https://x.com/geniusworld_ind" target="_blank"><i className='bx bxl-twitter' ></i></a>
                    <a href="https://www.instagram.com/geniusworld.travel/?__pwa=1" target="_blank"><i className='bx bxl-instagram-alt' ></i></a>
                    <a href="https://www.youtube.com/channel/UCkmFEEti3QzKySDPyvbl09A" target="_blank"><i className='bx bxl-youtube' ></i></a>
                    <a href="https://wa.me/919739737528" target="_blank" rel="noopener noreferrer"><i className='bx bxl-whatsapp' ></i></a>
                  </div>
                </div>
              </div>

            </div>
          </div>
          
        </div>

        <div className="footer-bottom">
          <div className="container">

            <div className="footer-warning">
              <div className="warning-icon">
                <Icons
                  name="shield_check"
                  width="34px"
                  height="34px"
                  fill="#ef4444"
                />
              </div>

              <div className="warning-content">
                <p>
                  <strong className="text-danger">Caution:</strong> Beware of Fake
                  Promotions or Offers. Please do not believe or engage with any
                  promotional emails, SMS or Web-link which ask you to click on a
                  link and fill in your details. All <strong>Genius World </strong>
                  authorized email communications are delivered from domain{" "}
                  <strong>@geniusworld.in</strong> or SMS from{" "}
                  <strong>GENIUS</strong>. Genius World bears no liability or
                  responsibility whatsoever for any communication which is fraudulent
                  or misleading in nature and not received from a registered domain.
                </p>
              </div>
            </div>
            <div className="border-top my-3"></div>
            <div className="footer-copyright ps-0">
              <p className="mb-0">
                Copyright © 2026 Genius World (CIN: U79120MH2024PTC418694). All rights reserved
              </p>
              <p className="mb-0 footer-powered-by">
                Powered By – <a target="_blank" href="https://gwcs.in/">GWCS</a>
              </p>
            </div>
          </div>
        </div>

      </footer>

      <PlanYourTripModal
        showModal={showPlanTripModal}
        setShowModal={setShowPlanTripModal}
        initialTab={planTripTab}
      />

    </>
  )
}
